import { Grid } from "@mui/material";
import Light from "../Refinery/Lights/Light";
import { RenderObject } from "../Refinery/Objects/RenderObject";
import { LightControls, LightControlsData } from "./LightControls";
import { ObjectControls, ObjectControlsData } from "./ObjectControls";


export type SelectedUpdateData = {
  objectData?: ObjectControlsData;
  lightData?: LightControlsData;
};


export type ControlsProps = {
  textures: string[];
  sceneRenderObjects: RenderObject[];
  onSelectedChange: (value: SelectedUpdateData) => void;
  onSelectedDelete: () => void;
  onSelectedClone: () => void;
  selectedObject?: RenderObject | Light;
};

export const Controls = (props: ControlsProps) => {
  if (!props.selectedObject) {
    return <></>;
  }

  return (
    <Grid spacing={2} width='100%' container>
      <Grid size={12}>
        {/* check if object or light */}
        {props.selectedObject instanceof RenderObject && (
          <ObjectControls
            onClone={props.onSelectedClone}
            onDelete={props.onSelectedDelete}
            possibleParentObjects={
              props.sceneRenderObjects.filter(v => v.name !== props.selectedObject?.name)
            }
            selectedObject={props.selectedObject}
            onSelectedChange={(d) => {
              props.onSelectedChange({ objectData: d });
            }}
            textures={props.textures}
          />
        )}
        {props.selectedObject instanceof Light && (
          <LightControls
            onClone={props.onSelectedClone}
            onDelete={props.onSelectedDelete}
            selectedObject={props.selectedObject}
            onSelectedChange={(d) => {
              props.onSelectedChange({ lightData: d });
            }}
          />
        )}
      </Grid>
    </Grid>
  )
};
